module.exports = __webpack_public_path__ + "static/media/success_grey.68063e82.svg";